export enum VariableSubType {
	Years = 'years',
	Months = 'months',
	Weeks = 'weeks',
	Days = 'days',
	Hours = 'hours',
	Minutes = 'minutes',
	Seconds = 'seconds'
}
